import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { storeAuth } from '@/lib/auth';
import { useRouter } from '@tanstack/react-router';
import { UserRole } from '@academia-apolo/shared-types';
import { ROUTES } from '@/lib/constants';
function getDefaultRoute(role) {
    switch (role) {
        case UserRole.DIRECTOR:
            return ROUTES.DIRECTOR_HOME;
        case UserRole.PROFESSOR:
            return ROUTES.PROFESSOR_HOME;
        case UserRole.STUDENT:
            return ROUTES.STUDENT_DASHBOARD;
        case UserRole.SUPPORT:
            return ROUTES.SUPPORT_INBOX;
        default:
            return ROUTES.DASHBOARD;
    }
}
export function useLogin() {
    const router = useRouter();
    return useMutation({
        mutationFn: (dto) => apiClient('/auth/login', {
            method: 'POST',
            body: JSON.stringify(dto),
            // A 401 here means bad credentials / locked account, not an expired
            // session — surface it as an ApiError instead of redirecting to /login.
            skipAuth: true,
        }),
        onSuccess: (data) => {
            const tokens = {
                accessToken: data.accessToken,
                refreshToken: data.refreshToken,
                expiresAt: data.expiresAt,
            };
            storeAuth(tokens, data.user);
            if (data.user.mustChangePassword) {
                void router.navigate({ to: ROUTES.CHANGE_PASSWORD });
            }
            else {
                void router.navigate({ to: getDefaultRoute(data.user.role) });
            }
        },
    });
}
//# sourceMappingURL=useLogin.js.map